export const XHourglassSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 512) * 493}
      viewBox="0 0 512 493"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M166.094 79.374C169.306 122.698 179.406 161.396 193.874 190.28C211.559 225.584 234.719 245.03 257.938 245.03C281.156 245.03 304.284 225.584 321.968 190.28C336.438 161.397 346.538 122.7 349.75 79.375H166.094V79.374Z"
        fill="url(#paint0_linear_290_6)"
      />
      <path
        d="M257.937 264.594C234.719 264.594 211.559 284.009 193.875 319.311C179.04 348.925 168.777 388.873 165.845 433.531H350C347.067 388.873 336.803 348.925 321.97 319.311C304.284 284.009 281.156 264.593 257.937 264.593V264.594Z"
        fill="url(#paint1_linear_290_6)"
      />
      <path
        d="M92.656 19.188V60.688H424.376V19.188H92.655H92.656Z"
        fill="url(#paint2_linear_290_6)"
      />
      <path
        d="M119.5 79.374V433.53H141.78V79.376H119.5V79.374Z"
        fill="url(#paint3_linear_290_6)"
      />
      <path
        d="M375.25 79.374V433.53H397.53V79.376H375.25V79.374Z"
        fill="url(#paint4_linear_290_6)"
      />
      <path
        d="M92.657 452.218V493.685H424.375V452.22H92.655L92.657 452.218Z"
        fill="url(#paint5_linear_290_6)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_290_6"
          x1="257.922"
          y1="79.374"
          x2="257.922"
          y2="245.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.546875" stopColor="#FFFDF1" />
          <stop offset="0.609375" stopColor="#FFEF97" />
          <stop offset="1" stopColor="#FFED8E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_290_6"
          x1="257.923"
          y1="264.593"
          x2="257.923"
          y2="433.531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.583333" stopColor="#FFFDF4" />
          <stop offset="0.630208" stopColor="#FFEF9F" />
          <stop offset="1" stopColor="#FFEC8B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_290_6"
          x1="258.516"
          y1="19.188"
          x2="258.516"
          y2="60.688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3C066" />
          <stop offset="1" stopColor="#886B22" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_290_6"
          x1="142"
          y1="256"
          x2="119"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#956216" />
          <stop offset="1" stopColor="#DBB34D" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_290_6"
          x1="374"
          y1="271.5"
          x2="398"
          y2="271.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDAF39" />
          <stop offset="1" stopColor="#927615" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_290_6"
          x1="258.515"
          y1="452.218"
          x2="258.515"
          y2="493.685"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C7A654" />
          <stop offset="0.9999" stopColor="#876721" />
          <stop offset="1" stopColor="#714F0F" />
        </linearGradient>
      </defs>
    </svg>
  );
};
